module.exports = __webpack_public_path__ + "img/premium-section-background2.d9fe534.jpg";